import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Fab, useTheme, useMediaQuery } from '@mui/material';
import { Add } from '@mui/icons-material';

const MobileFab = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const user = useSelector(state => state.auth.user);

  if (!isMobile || !['Admin', 'Sample Collector'].includes(user?.role)) {
    return null;
  }

  return (
    <Fab
      color="primary"
      aria-label="add sample"
      onClick={() => navigate('/samples/create')}
      sx={{
        position: 'fixed',
        bottom: 80, // Above bottom navigation
        right: 16,
        zIndex: 1000,
        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.4)',
        '&:hover': {
          boxShadow: '0 6px 16px rgba(25, 118, 210, 0.6)',
        },
      }}
    >
      <Add />
    </Fab>
  );
};

export default MobileFab;